export const stateOptions = [
  { codeValue: 'AL', shortName: 'Alabama' },
  { codeValue: 'AK', shortName: 'Alaska' },
  { codeValue: 'AZ', shortName: 'Arizona' },
  { codeValue: 'AR', shortName: 'Arkansas' },
  { codeValue: 'CA', shortName: 'California' },
  { codeValue: 'CO', shortName: 'Colorado' },
  { codeValue: 'CT', shortName: 'Connecticut' },
  { codeValue: 'DE', shortName: 'Delaware' },
  { codeValue: 'DC', shortName: 'District of Columbia' },
  { codeValue: 'FL', shortName: 'Florida' },
  { codeValue: 'GA', shortName: 'Georgia' },
  { codeValue: 'HI', shortName: 'Hawaii' },
  { codeValue: 'ID', shortName: 'Idaho' },
  { codeValue: 'IL', shortName: 'Illinois' },
  { codeValue: 'IN', shortName: 'Indiana' },
  { codeValue: 'IA', shortName: 'Iowa' },
  { codeValue: 'KS', shortName: 'Kansas' },
  { codeValue: 'KY', shortName: 'Kentucky' },
  { codeValue: 'LA', shortName: 'Louisiana' },
  { codeValue: 'ME', shortName: 'Maine' },
  { codeValue: 'MD', shortName: 'Maryland' },
  { codeValue: 'MA', shortName: 'Massachusetts' },
  { codeValue: 'MI', shortName: 'Michigan' },
  { codeValue: 'MN', shortName: 'Minnesota' },
  { codeValue: 'MS', shortName: 'Mississippi' },
  { codeValue: 'MO', shortName: 'Missouri' },
  { codeValue: 'MT', shortName: 'Montana' },
  { codeValue: 'NE', shortName: 'Nebraska' },
  { codeValue: 'NV', shortName: 'Nevada' },
  { codeValue: 'NH', shortName: 'New Hampshire' },
  { codeValue: 'NJ', shortName: 'New Jersey' },
  { codeValue: 'NM', shortName: 'New Mexico' },
  { codeValue: 'NY', shortName: 'New York' },
  { codeValue: 'NC', shortName: 'North Carolina' },
  { codeValue: 'ND', shortName: 'North Dakota' },
  { codeValue: 'OH', shortName: 'Ohio' },
  { codeValue: 'OK', shortName: 'Oklahoma' },
  { codeValue: 'OR', shortName: 'Oregon' },
  { codeValue: 'PA', shortName: 'Pennsylvania' },
  { codeValue: 'RI', shortName: 'Rhode Island' },
  { codeValue: 'SC', shortName: 'South Carolina' },
  { codeValue: 'SD', shortName: 'South Dakota' },
  { codeValue: 'TN', shortName: 'Tennessee' },
  { codeValue: 'TX', shortName: 'Texas' },
  { codeValue: 'UT', shortName: 'Utah' },
  { codeValue: 'VT', shortName: 'Vermont' },
  { codeValue: 'VA', shortName: 'Virginia' },
  { codeValue: 'WA', shortName: 'Washington' },
  { codeValue: 'WV', shortName: 'West Virginia' },
  { codeValue: 'WI', shortName: 'Wisconsin' },
  { codeValue: 'WY', shortName: 'Wyoming' },
];

export const STEPS = {
  step0: 'step0', // welcome
  step1: 'step1', // w4 personal info
  step2: 'step2', // w4 multiple jobs or spouse works
  step3: 'step3', // w4 claim dependents
  step4: 'step4', // other adjustments
  step5: 'step5', // review
  step6: 'step6', // signing
};

export const step1Questions = [
  {
    id: 'first_name',
    title: 'First name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'middle_name',
    title: 'Middle initial',
    is_required: false,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[a-zA-Z]{1}$',
        customErrorMessage: 'The middle initial can only contain 1 letter.',
      },
    ],
  },
  {
    id: 'last_name',
    title: 'Last name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'address',
    title: 'Address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
  {
    id: 'ssn',
    title: 'SSN',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'federal_filing_status',
    title: 'Federal filing status (1c)',
    is_required: require,
    question_type: 'multiple_choice',
    options: [
      {
        codeValue: 'single',
        shortName: 'Single',
      },
      {
        codeValue: 'married_filing_separately',
        shortName: 'Married filing separately',
      },
      {
        codeValue: 'married_filing_jointly',
        shortName: 'Married filing jointly',
      },
      {
        codeValue: 'widowed',
        shortName: 'Qualifying surviving spouse',
      },
      {
        codeValue: 'head_of_household',
        shortName: 'Head of household',
      },
    ],
  },
];

export const formLink = 'https://www.irs.gov/pub/irs-pdf/fw4.pdf';
